import { handleResponse, handleError, getBaseUrlPortal } from "./apiUtils";
import { store } from "../redux/configureStore"; // adjust path as needed
//const baseUrl = process.env.API_URL + "/clubs/";
const baseUrl = getBaseUrlPortal(); //"https://localhost:44354/api/";
const apiKey = "ca89dd70-63cb-4e8e-af44-bc22062563cf"; // Replace with your actual API key

/**
 * Converts requestedSlots from object format to array format
 * @param {Object} slotsObject - Object in format: {2025-10-08: {start: '09:30', end: '10:00'}}
 * @returns {Array} Array in format: [{data: '2025-10-08', startTime: '09:30', endTime: '10:00'}]
 */
export function convertRequestedSlotsToArray(slotsObject) {
  return Object.entries(slotsObject).map(([date, timeSlot]) => ({
    data: date,
    startTime: timeSlot.start,
    endTime: timeSlot.end,
  }));
}
async function handleDatiScuolaResponse(response) {
  if (response.ok) return response.json();
  alert(
    "Errore nel caricamento dei dati della scuola. Verifica la connessione a internet. 1"
  );
  window.location.href = "/";
}

export function getDatiScuola(idScuola, lang) {
  console.log("LOADING SCHOOL DATA");

  return fetch(`${baseUrl}scuole/${idScuola}?lang=${lang}`, {
    headers: {
      "X-SK-ApiKey": apiKey,
    },
  })
    .then(handleDatiScuolaResponse)
    .catch(handleError);
}

export function getDisponibilitàGiorno(
  data,
  idArea,
  idSpecialita,
  idLivello,
  lingua,
  idMaestro,
  righePrivateNew = []
) {
  console.log("LOADING AVAILABILITY FOR DAY", {
    data,
    idArea,
    idSpecialita,
    idLivello,
    idMaestro,
    righePrivateNew,
  });

  // Validate all parameters are required
  if (!data) {
    return Promise.reject(new Error("Data is required"));
  }
  if (!idArea) {
    return Promise.reject(new Error("Area operativa ID is required"));
  }
  if (!idSpecialita) {
    return Promise.reject(new Error("Specialita ID is required"));
  }
  if (!idLivello) {
    return Promise.reject(new Error("Livello ID is required"));
  }

  // Get the scuolaId from Redux store
  const state = store.getState();
  const scuolaId = state.scuolaNewReducer?.id;

  // Build the URL with all required parameters
  const url = `${baseUrl}disponibilita/disponibilitagiorno?data=${encodeURIComponent(
    data
  )}&areaOperativaId=${encodeURIComponent(
    idArea
  )}&specialitaId=${encodeURIComponent(
    idSpecialita
  )}&livelloId=${encodeURIComponent(idLivello)}&maestroId=${encodeURIComponent(
    idMaestro ?? -1
  )}&lingua=${encodeURIComponent(lingua)}`;

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-SK-ApiKey": apiKey,
      "X-SPA-TenantId": scuolaId || "",
    },
    body: JSON.stringify(righePrivateNew),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getGiorniNonDisponibili(
  dataInizio,
  idArea,
  idSpecialita,
  idLivello,
  lingua,
  dalle,
  alle
) {
  console.log("LOADING NON-SELECTABLE DATES", {
    dataInizio,
    idArea,
    idSpecialita,
    idLivello,
    dalle,
    alle,
  });

  // Validate all parameters are required
  if (!dataInizio) {
    return Promise.reject(new Error("Data inizio is required"));
  }
  if (!idArea) {
    return Promise.reject(new Error("Area operativa ID is required"));
  }
  if (!idSpecialita) {
    return Promise.reject(new Error("Specialita ID is required"));
  }
  if (!idLivello) {
    return Promise.reject(new Error("Livello ID is required"));
  }
  if (!dalle) {
    return Promise.reject(new Error("Dalle time is required"));
  }
  if (!alle) {
    return Promise.reject(new Error("Alle time is required"));
  }

  // Get the scuolaId from Redux store
  const state = store.getState();
  const scuolaId = state.scuolaNewReducer?.id;

  // Build the URL with all required parameters
  const url = `${baseUrl}disponibilita/datenonselezionabili?dataInizio=${encodeURIComponent(
    dataInizio
  )}&areaOperativaId=${encodeURIComponent(
    idArea
  )}&specialitaId=${encodeURIComponent(
    idSpecialita
  )}&livelloId=${encodeURIComponent(idLivello)}&dalle=${encodeURIComponent(
    dalle
  )}&alle=${encodeURIComponent(alle)}&lingua=${encodeURIComponent(lingua)}`;

  return fetch(url, {
    headers: {
      "X-SK-ApiKey": apiKey,
      "X-SPA-TenantId": scuolaId || "",
    },
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getDisponibilitaMigliore(
  primoGiorno,
  dalle,
  alle,
  areaOperativaId,
  specialitaId,
  livelloId,
  altriGiorniRichiesti,
  idMaestro,
  lingua,
  righePrivateNew = []
) {
  // Validate required parameters
  if (!primoGiorno) return Promise.reject(new Error("primoGiorno is required"));
  if (!dalle) return Promise.reject(new Error("dalle is required"));
  if (!alle) return Promise.reject(new Error("alle is required"));
  if (!areaOperativaId)
    return Promise.reject(new Error("areaOperativaId is required"));
  if (!specialitaId)
    return Promise.reject(new Error("specialitaId is required"));
  if (!livelloId) return Promise.reject(new Error("livelloId is required"));
  if (!Array.isArray(altriGiorniRichiesti))
    return Promise.reject(new Error("altriGiorniRichiesti must be an array"));

  // Get scuolaId from Redux store
  const state = store.getState();
  const scuolaId = state.scuolaNewReducer?.id;

  // Build URL with query parameters
  const url = `${baseUrl}disponibilita/disponibilitamigliore?primoGiorno=${encodeURIComponent(
    primoGiorno
  )}&dalle=${encodeURIComponent(dalle)}&alle=${encodeURIComponent(
    alle
  )}&areaOperativaId=${encodeURIComponent(
    areaOperativaId
  )}&specialitaId=${encodeURIComponent(
    specialitaId
  )}&livelloId=${encodeURIComponent(livelloId)}&maestroId=${encodeURIComponent(
    idMaestro ?? -1
  )}&lingua=${encodeURIComponent(lingua)}`;

  // Create DTO with both altriGiorniRichiesti and righeCarrello
  const requestData = {
    altriGiorniRichiesti,
    righeCarrello: righePrivateNew,
  };

  // POST request with requestData DTO in body
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-SK-ApiKey": apiKey,
      "X-SPA-TenantId": scuolaId || "",
    },
    body: JSON.stringify(requestData),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getGiorniCompletamenteNonDisponibili(
  areaOperativaId,
  specialitaId,
  livelloId,
  lingua,
  idMaestro,
  righePrivateNew = []
) {
  console.log("LOADING GIORNI COMPLETAMENTE NON DISPONIBILI", {
    areaOperativaId,
    specialitaId,
    livelloId,
    lingua,
    idMaestro,
    righePrivateNew,
  });

  // Validate all parameters are required
  if (!areaOperativaId) {
    return Promise.reject(new Error("Area operativa ID is required"));
  }
  if (!specialitaId) {
    return Promise.reject(new Error("Specialita ID is required"));
  }
  if (!livelloId) {
    return Promise.reject(new Error("Livello ID is required"));
  }
  if (!lingua) {
    return Promise.reject(new Error("Lingua is required"));
  }

  // Get the scuolaId from Redux store
  const state = store.getState();
  const scuolaId = state.scuolaNewReducer?.id;

  // Build the URL with all required parameters
  const url = `${baseUrl}disponibilita/giornicompletamentenondisponibili?areaOperativaId=${encodeURIComponent(
    areaOperativaId
  )}&specialitaId=${encodeURIComponent(
    specialitaId
  )}&livelloId=${encodeURIComponent(livelloId)}&lingua=${encodeURIComponent(
    lingua
  )}&idMaestro=${encodeURIComponent(idMaestro ?? -1)}`;

  // If there are cart items, send them in the request body
  //if (righePrivateNew && righePrivateNew.length > 0) {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-SK-ApiKey": apiKey,
      "X-SPA-TenantId": scuolaId || "",
    },
    body: JSON.stringify(righePrivateNew),
  })
    .then(handleResponse)
    .catch(handleError);
  // } else {
  //   // If no cart items, use GET request as before
  //   return fetch(url, {
  //     headers: {
  //       "X-SK-ApiKey": apiKey,
  //       "X-SPA-TenantId": scuolaId || "",
  //     },
  //   })
  //     .then(handleResponse)
  //     .catch(handleError);
  // }
}

export function calcolaPrezzoLezioniPrivate(
  requestedSlots,
  numberOfPeople,
  specialitaId
) {
  // Check if requestedSlots is an object (needs conversion) or already an array
  const slotsArray = Array.isArray(requestedSlots)
    ? requestedSlots
    : convertRequestedSlotsToArray(requestedSlots);

  const datiLezioni = {
    requestedSlots: slotsArray.map((slot) => ({
      date: slot.data,
      startTime: slot.startTime || slot.start,
      endTime: slot.endTime || slot.end,
    })),
    numberOfPeople,
    specialitaId,
  };

  // Get scuolaId from Redux store
  const state = store.getState();
  const scuolaId = state.scuolaNewReducer?.id;

  // Build URL
  const url = `${baseUrl}pricing/prezzoprivate`;

  // POST request with datiLezioni in body
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-SK-ApiKey": apiKey,
      "X-SPA-TenantId": scuolaId || "",
    },
    body: JSON.stringify(datiLezioni),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function ValidaEScegliRitrovo(
  idMaestroSkiwork,
  idSpecialitaSkiwork,
  idLivelloSkiwork,
  idAreaOperativaSkiwork,
  lezioni
) {
  console.log("VERIFICA FINALE PRIVATENEW", {
    idAreaOperativaSkiwork,
    idSpecialitaSkiwork,
    idLivelloSkiwork,
    idMaestroSkiwork,
    lezioni,
  });

  // Validate all parameters are required
  if (!idAreaOperativaSkiwork) {
    return Promise.reject(new Error("Area operativa ID is required"));
  }
  if (!((idSpecialitaSkiwork ?? -1) >= 0)) {
    return Promise.reject(new Error("Specialita ID is required"));
  }
  if (!idLivelloSkiwork) {
    return Promise.reject(new Error("Livello ID is required"));
  }
  if (!idMaestroSkiwork) {
    return Promise.reject(new Error("Maestro ID is required"));
  }

  // Get the scuolaId from Redux store
  const state = store.getState();
  const scuolaId = state.scuolaNewReducer?.id;

  // Build the URL with all required parameters
  const url = `${baseUrl}disponibilita/validaEScegliRitrovo`;

  var slotRichiesti = lezioni.map((lezione) => ({
    date: lezione.Data,
    dalle: lezione.Dalle,
    alle: lezione.Alle,
  }));

  console.log("SLOT RICHIESTI:", slotRichiesti);

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-SK-ApiKey": apiKey,
      "X-SPA-TenantId": scuolaId || "",
    },
    body: JSON.stringify({
      idAreaOperativaSkiwork,
      idSpecialitaSkiwork,
      idLivelloSkiwork,
      idMaestroSkiwork,
      lezioni: slotRichiesti,
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}
